import { Typography } from '@mui/material'
import { localStorageItemKeys } from '~constants/local-storage-items'
import { WarningRibbon } from '~components/warning-ribbon'

export function ImpersonationRibbon() {
  const impersonating = localStorage.getItem(localStorageItemKeys.impersonate)
  if (!impersonating) {
    return null
  }

  const impersonate = JSON.parse(impersonating)
  const displayLabel = impersonate?.redactedLabel || impersonate?.label
  if (!impersonate?.id || !displayLabel) {
    removeImpersonation()
    return null
  }

  return (
    <WarningRibbon
      message={
        <>
          You are impersonating{' '}
          <Typography variant="paragraphBold1">{displayLabel}</Typography>
        </>
      }
      buttonLabel="Stop impersonation"
      onButtonClick={stopImpersonation}
    />
  )
}

function removeImpersonation() {
  localStorage.removeItem(localStorageItemKeys.impersonate)
  window.location.reload()
}

function stopImpersonation() {
  localStorage.removeItem(localStorageItemKeys.impersonate)
  window.location.href = '/profile'
}
